export const Arabic = {  
  aboutBespoken: "حول بيسبوكن",
  ourFeatures: "مميزاتنا",
  FAQs: "الأسئلة الشائعة",
  contactUs: "اتصل بنا",
  getTheApp: "حمّل التطبيق",
  weShopYouSlayPersonalizedPicksThatMatchYourVibe: "نحن نتسوق، وأنت تتألق. اختيارات مخصصة تناسب ذوقك.",
  aboutUs: "من نحن",
  fullName: "الاسم الكامل",
  emailAddress: "عنوان البريد الإلكتروني",
  phoneNumber: "رقم الهاتف",
  message: "رسالة",
  howCanEeHelpYou: "كيف يمكننا مساعدتك؟",
  BespokenFeatures: "مميزات بيسبوكن",
  sendAMessage: "إرسال رسالة",
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  TermsAConditions: "الأحكام والشروط",
  PrivacyPolicy: "سياسة الخصوصية",
  Technozone: "تيكنوزون",
  TermsAndConditions: "الشروط والأحكام",
  PrivacyAndPolicy: "الخصوصية والسياسة",
  answers: "الإجابات",
  WillContactYouAsSoonAsPosible: "شكرًا لتواصلك معنا، سنتواصل معك في أقرب وقت ممكن",
  pleaseFillTheFormInTheRightWay: "يرجى تعبئة النموذج بالطريقة الصحيحة",
  enterYourFullName: "أدخل اسمك الكامل",
  enterYourEmail: "أدخل بريدك الإلكتروني",
  enterYourPhoneNumber: "أدخل رقم هاتفك",
  thisFieldIsRequired: "هذا الحقل مطلوب",
  selectYourMomentsOrCity: "اختر لحظاتك أو مدينتك",
  shareAnySpaceFromASharedLivingRoomToASecondHomeAndEverythingInBetween: "شارك أي مساحة من غرفة معيشة مشتركة إلى منزل ثانٍ وكل ما بينهما.",
  chooseYourDate: "اختر تاريخك" ,


    
    
    
    youreFreeToChooseYourOwnSchedulePricesAndRequirementsForGuests: "أنت حر في اختيار جدولك وأسعارك ومتطلباتك للضيوف.",
    enjoyThePhotoshoot: "استمتع بجلسة التصوير",
    onceYourListingIsLiveQualifiedGuestsCanReachOutAndYouCanMessageThem: "بمجرد أن يصبح إعلانك نشطًا، يمكن للضيوف المؤهلين التواصل معك ويمكنك مراسلتهم.",
    getYourFilesOnlyOn48Hours: "احصل على ملفاتك خلال 48 ساعة فقط"
};
